import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Registry to store save functions outside of Redux state
class SaveFunctionRegistry {
    private functions: Map<string, () => void> = new Map();
    private currentId: string | null = null;

    register(id: string, saveFunction: () => void): void {
        this.functions.set(id, saveFunction);
        this.currentId = id;
    }

    unregister(id: string): void {
        this.functions.delete(id);
        if (this.currentId === id) {
            this.currentId = null;
        }
    }

    getCurrentFunction(): (() => void) | null {
        if (this.currentId && this.functions.has(this.currentId)) {
            return this.functions.get(this.currentId) || null;
        }
        return null;
    }

    getCurrentId(): string | null {
        return this.currentId;
    }

    clear(): void {
        this.functions.clear();
        this.currentId = null;
    }
}

export const saveFunctionRegistry = new SaveFunctionRegistry();

interface ConfigurationState {
    currentSaveFunctionId: string | null;
}

const initialState: ConfigurationState = {
    currentSaveFunctionId: null,
};

export const configurationSlice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setCurrentSaveFunction(state, action: PayloadAction<string>) {
            state.currentSaveFunctionId = action.payload;
        },
        clearCurrentSaveFunction(state) {
            state.currentSaveFunctionId = null;
        },
    }
});

export const { 
    setCurrentSaveFunction, 
    clearCurrentSaveFunction 
} = configurationSlice.actions;

export default configurationSlice.reducer;
